import { withViewerBoundary } from '../Viewer3DBoundary';
import { Room3DViewer as Room3DViewerBase } from './Room3DViewer';
import { Wall3DViewer as Wall3DViewerBase } from './Wall3DViewer';

// Wrapped so a WebGL failure shows a placeholder instead of crashing the wizard.
export const Room3DViewer = withViewerBoundary(Room3DViewerBase);
export const Wall3DViewer = withViewerBoundary(Wall3DViewerBase);
export type { Room3DViewerProps } from './types';
